export default __webpack_public_path__ + "static/media/pencil.27c54e95.svg";